module.exports = __webpack_public_path__ + "media/images/recruit/section/mv_department11-4e26c34ba964d425def281a66ffafbe2.jpg";